import { useQuery } from '@tanstack/react-query'
import ProcessesApi from '@/infrastructure/api/processes'

function getQueryKey(processId?: string) {
  return ['performedReviews', processId]
}

export function usePerformedReviews(processId?: string) {
  function callPerformedReviews() {
    if (!processId) return
    return ProcessesApi.getReviews({ processId })
  }

  const performedReviewsQuery = useQuery({
    queryKey: getQueryKey(processId),
    queryFn: callPerformedReviews,
    staleTime: 1000 * 60 * 15
  })

  return {
    performedReviews: performedReviewsQuery.data ?? [],
    loadingPerformedReviews: performedReviewsQuery.isLoading
  }
}
